import { render, staticRenderFns } from "./ListJiko.vue?vue&type=template&id=10b6cff8&"
import script from "./ListJiko.vue?vue&type=script&lang=ts&"
export * from "./ListJiko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports